<template>
	<div class="modal fade" :id="modal.selector" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog">
			<div v-if="department" class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
					<h4 class="modal-title">{{ department.name }}</h4>
				</div>
				<div class="modal-body">
					<ul v-if="department_users" class="list-group list-group-full">
						<li v-for="department_user in department_users" class="list-group-item">
							{{ department_user.email }}
							<span v-if="!department_user.disabled">
								<button @click="quitUser(department_user)" :title="$t('interface.actions.quit')" v-if="department_user.selected" class="btn btn-danger">
									<i class="fa fa-minus" aria-hidden="true"></i>
								</button>
								<button @click="addUser(department_user)" :title="$t('interface.actions.add')" v-else class="btn btn-success">
									<i class="fa fa-plus" aria-hidden="true"></i>
								</button>
							</span>
						</li>
					</ul>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default waves-effect" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth', 'users', 'department', 'disabled', 'newUsers'],
		data () {
			return {
				modal: {
					selector: 'users-department-modal',
				},

				department_users: [],
			}
		},
		created() {
			this.init()
		},
		methods: {
			init () {
				this.initModal()
			},
			initModal () {
				this.modal.element = $('#'+this.modal.selector)
			},
			open () {
				this.department_users = null
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
				this.getData()
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getData () {
				if(this.department) {
					this.$http.get('admin/departments/' + this.department.id + '/users')
					.then(response => {
						this.department_users = response.body
						this.filterUsers()
					}).catch(function(response) {
						console.log(response)
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					})
				}
			},
			filterUsers () {
				if(this.department_users) {
					if(this.department_users.length) {
						if(this.users) {
							if(this.users.length) {
								var that = this
								this.users.map(function(e) {
									for (var i = 0; i < that.department_users.length; i++) {
										var element = that.department_users[i]
										if(!element.selected) {
											if(element.id == e.id) {
												if(that.disabled) {
													that.$set(element, 'disabled', true)
												}
												that.$set(element, 'selected', true)
											} else {
												that.$set(element, 'selected', false)
											}
										}
									}
								})
							}
						}
					}
				}

				if(this.newUsers) {
					if(this.newUsers.length) {
						if(this.department_users) {
							if(this.department_users.length) {
								var that = this
								this.newUsers.map(function(e) {
									for (var i = 0; i < that.department_users.length; i++) {
										var element = that.department_users[i]
										if(!element.selected) {
											if(element.id == e.id) {
												that.$set(element, 'selected', true)
											} else {
												that.$set(element, 'selected', false)
											}
										}
									}
								})
							}
						}
					}
				}
			},
			addUser(user) {
				this.$set(user, 'selected', true)
				if(this.newUsers) {
					this.newUsers.push(user)
				} else {
					this.users.push(user)
				}
			},
			quitUser(user) {
				this.$set(user, 'selected', false)
				let index = this.users.indexOf(user)
				if(this.newUsers) {
					this.newUsers.splice(index, 1)
				} else {
					this.users.splice(index, 1)
				}
			},
		},
		mounted () {
			var modal = $('#'+this.modal.selector)
			modal.on('show.bs.modal', '.modal', function (event) {
				var zIndex = 1040 + (10 * $('.modal:visible').length)
				$(this).css('z-index', zIndex)
				setTimeout(function() {
					$('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
				}, 0);
			});

			$(document).on('hidden.bs.modal', '.modal', function () {
				$('.modal:visible').length && $(document.body).addClass('modal-open');
			});
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/departments/views/Modal.vue